// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".badge-icon__items[data-v-54abe033]{display:flex;flex-direction:column;grid-gap:10px;gap:10px}.badge-icon__btn[data-v-54abe033]{transition:transform .3s ease}.badge-icon__btn.ant-popover-open[data-v-54abe033]{transform:rotate(-18deg)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
